import { css } from '@repo/pandacss/styled-system/css';
import { createElement, Fragment } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import { TypeProps } from './type';

export function Type({ props: { bold, children, italic, nested, rendererProps } }: TypeProps) {
  let Component = nested ? 'span' : 'p';
  if (bold) {
    Component = 'strong';
  }

  return createElement(Component, {
    className: css({
      textStyle: 'text',
      whiteSpace: 'pre-line',
      fontSize: bold ? '[inherit]' : '[initial]',
      fontStyle: italic ? '[italic]' : undefined,
      fontWeight: bold ? '[700]' : '[inherit]',
    }),
    children: [children].flat().map((child, idx) => {
      if (typeof child === 'string') {
        if (child === '\n') {
          return <br key={idx} />;
        }
        return <Fragment key={idx}>{child}</Fragment>;
      }
      let newChild = child;
      if (child && typeof child === 'object' && 'type' in child && child.type === 'Type') {
        newChild = {
          ...child,
          props: {
            ...child.props,
            nested: true,
          },
        };
      }
      return <Fragment key={idx}>{renderStructuredContent(newChild, rendererProps)}</Fragment>;
    }),
  });
}
